module.exports = __webpack_public_path__ + "static/img/bookmark2.b340b21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/student-smart/bookmark2.jpg
// module id = A418
// module chunks = 1